// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.properties-view input[type="text"] {
  width: 800px;
}
.properties-view textarea {
  max-width: 800px;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/libs/project/top-level/feature/Properties.less"],"names":[],"mappings":"AAAA;EAEI,YAAA;AAAJ;AAFA;EAMI,gBAAA;AADJ","sourcesContent":[".properties-view {\n  input[type=\"text\"] {\n    width: 800px;\n  }\n\n  textarea {\n    max-width: 800px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
